import { render } from "./StandardContentIndex.vue?vue&type=template&id=38e8dcdb&scoped=true"
import script from "./StandardContentIndex.vue?vue&type=script&lang=js"
export * from "./StandardContentIndex.vue?vue&type=script&lang=js"

import "./StandardContentIndex.vue?vue&type=style&index=0&id=38e8dcdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e8dcdb"]])

export default __exports__